/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */

import {GPGPUProgram} from './gpgpu_math';

export class ComplexAbsProgram implements GPGPUProgram {
  variableNames = ['real', 'imag'];
  userCode: string;
  outputShape: number[];

  constructor(shape: number[]) {
    this.outputShape = shape;
    this.userCode = `
      void main() {
        float real = getRealAtOutCoords();
        float imag = getImagAtOutCoords();
        vec2 v = vec2(real, imag);

        setOutput(sqrt(dot(v, v)));
      }
    `;
  }
}
